@use "/src/styles/functions.scss";

.productKeyIcon {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: functions.radius(full);
  flex: 0 0 auto;

  &[data-variant="stroke"] {
    background: functions.getColor(var(--theme-bg-white-0));
    border: 1px solid functions.getColor(var(--theme-stroke-soft-200));
    box-shadow: 0px 1px 2px rgba(14, 18, 27, 0.05);

    &[data-color="primary"] {
      color: functions.getColor(var(--theme-primary-base));
    }
    &[data-color="secondary"] {
      color: functions.getColor(var(--theme-secondary-600));
    }
    &[data-color="gray"] {
      color: functions.getColor(var(--theme-icon-sub-600));
    }
    &[data-color="blue"] {
      color: functions.getColor(var(--theme-state-information-base));
    }
    &[data-color="orange"] {
      color: functions.getColor(var(--theme-state-warning-base));
    }
    &[data-color="red"] {
      color: functions.getColor(var(--theme-state-error-base));
    }
    &[data-color="green"] {
      color: functions.getColor(var(--theme-state-success-base));
    }
    &[data-color="yellow"] {
      color: functions.getColor(var(--theme-state-away-base));
    }
    &[data-color="purple"] {
      color: functions.getColor(var(--theme-state-feature-base));
    }
    &[data-color="pink"] {
      color: functions.getColor(var(--theme-state-highlighted-base));
    }
    &[data-color="sky"] {
      color: functions.getColor(var(--theme-state-verified-base));
    }
  }

  &[data-variant="lighter"] {
    &[data-color="primary"] {
      color: functions.getColor(var(--theme-primary-base));
      background: functions.getColor(var(--theme-state-warning-lighter));
    }
    &[data-color="secondary"] {
      color: functions.getColor(var(--theme-secondary-600));
      background: functions.getColor(var(--theme-secondary-50));
    }
    &[data-color="gray"] {
      color: functions.getColor(var(--theme-icon-sub-600));
      background: functions.getColor(var(--theme-state-faded-lighter));
    }
    &[data-color="blue"] {
      color: functions.getColor(var(--theme-state-information-base));
      background: functions.getColor(var(--theme-state-information-lighter));
    }
    &[data-color="orange"] {
      color: functions.getColor(var(--theme-state-warning-base));
      background: functions.getColor(var(--theme-state-warning-lighter));
    }
    &[data-color="red"] {
      color: functions.getColor(var(--theme-state-error-base));
      background: functions.getColor(var(--theme-state-error-lighter));
    }
    &[data-color="green"] {
      color: functions.getColor(var(--theme-state-success-base));
      background: functions.getColor(var(--theme-state-success-lighter));
    }
    &[data-color="yellow"] {
      color: functions.getColor(var(--theme-state-away-base));
      background: functions.getColor(var(--theme-state-away-lighter));
    }
    &[data-color="purple"] {
      color: functions.getColor(var(--theme-state-feature-base));
      background: functions.getColor(var(--theme-state-feature-lighter));
    }
    &[data-color="pink"] {
      color: functions.getColor(var(--theme-state-highlighted-base));
      background: functions.getColor(var(--theme-state-highlighted-lighter));
    }
    &[data-color="sky"] {
      color: functions.getColor(var(--theme-state-verified-base));
      background: functions.getColor(var(--theme-state-verified-lighter));
    }
  }

  &[data-size="2x-large"] {
    padding: functions.space(16);
    width: functions.toRem(64);
    height: functions.toRem(64);
  }
  &[data-size="x-large"] {
    padding: functions.space(14);
    width: functions.toRem(56);
    height: functions.toRem(56);
  }
  &[data-size="large"] {
    padding: functions.space(12);
    width: functions.toRem(48);
    height: functions.toRem(48);
  }
  &[data-size="medium"] {
    padding: functions.space(10);
    width: functions.toRem(40);
    height: functions.toRem(40);
  }
  &[data-size="small"] {
    padding: functions.space(6);
    width: functions.toRem(32);
    height: functions.toRem(32);
  }
  &[data-size="x-small"] {
    padding: functions.space(4);
    width: functions.toRem(24);
    height: functions.toRem(24);
  }

  &[data-disabled="true"] {
    color: functions.getColor(var(--theme-icon-disabled-300)) !important;
  }
}
